import React from 'react';
import { EmotionType, EMOTION_LABELS } from '../../../types/annotation';

interface EmotionSelectorProps {
  value: EmotionType | null;
  onChange: (v: EmotionType) => void;
  disabled?: boolean;
}

const EMOTION_ORDER: EmotionType[] = [
  'neutral',
  'angry',
  'sad',
  'happy',
  'fearful',
  'sarcastic',
  'frustrated',
  'hesitant',
  'confident',
  'excited',
  'disappointed',
];

const EmotionSelector: React.FC<EmotionSelectorProps> = ({ value, onChange, disabled = false }) => {
  return (
    <div className="grid grid-cols-3 gap-1.5">
      {EMOTION_ORDER.map((emotion) => {
        const isActive = value === emotion;
        return (
          <button
            key={emotion}
            type="button"
            disabled={disabled}
            onClick={() => onChange(emotion)}
            className={[
              'px-2 py-1.5 text-xs rounded-lg font-medium transition-colors text-center',
              isActive
                ? 'bg-violet-600 text-white ring-2 ring-violet-400'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
              disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
            ].join(' ')}
          >
            {EMOTION_LABELS[emotion]}
          </button>
        );
      })}
    </div>
  );
};

export default EmotionSelector;
